import { render, staticRenderFns } from "./LuckDrawNew.vue?vue&type=template&id=ef943bd4&scoped=true"
import script from "./LuckDrawNew.vue?vue&type=script&lang=js"
export * from "./LuckDrawNew.vue?vue&type=script&lang=js"
import style0 from "./LuckDrawNew.vue?vue&type=style&index=0&id=ef943bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef943bd4",
  null
  
)

export default component.exports